var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightningBolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91148 0.833313C9.30118 0.833313 10.0979 2.25577 9.50818 3.43524L8.30533 5.84092C9.95874 5.9677 10.8231 7.65431 9.90381 9.09884L4.51852 17.5614C3.50346 19.1565 1.03696 18.0966 1.49551 16.2624L2.64445 11.6666H2.28689C0.683663 11.6666 -0.379378 10.2049 0.127429 8.68448L2.29774 2.17354C2.56307 1.37754 3.32059 0.833313 4.15402 0.833313H7.91148ZM7.91148 2.49998H4.15402C4.039 2.49998 3.91767 2.58421 3.87888 2.70059L1.70857 9.21152C1.56342 9.64698 1.81521 9.99998 2.28689 9.99998H4.77908L3.11242 16.6666L8.4977 8.20405C8.74515 7.8152 8.57629 7.49998 8.10461 7.49998H5.61242L8.01746 2.68988C8.0699 2.585 8.02191 2.49998 7.91148 2.49998Z",
    fill: "#E8474E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBolt);
export default __webpack_public_path__ + "static/media/lightning-bolt.fa8763db7d90e9da97a7be97472925bb.svg";
export { ForwardRef as ReactComponent };